import { proxy } from 'valtio';
import { TrackedError, TrackedEvent } from './types';
import { valtioDevTools } from '@lib/utils/devTools';

export type DiagnosticsState = {
  errors: readonly TrackedError[];
  events: readonly TrackedEvent[];
  drawerOpen: boolean;
};

export const diagnosticsInitState = {
  errors: [],
  events: [],
  drawerOpen: false,
};

export const diagnosticsState = proxy<DiagnosticsState>(diagnosticsInitState);

valtioDevTools(diagnosticsState, 'diagnosticsState');
